import * as React from "react"

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { withStyles, Theme, WithStyles, createTheme, ThemeProvider } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogActions from '@material-ui/core/DialogActions';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';
import { BrowserRouter, Route, Link } from 'react-router-dom';
import { Grid, Paper } from "@material-ui/core";

import ResponsiveImgMaterialUi from 'responsive-img-material-ui';
import { AppState, IPageState } from "appredux";
import { connect } from "react-redux";
import CONFIG from "cfg/config";

import platnosciLogo from 'zdjecia/Przelewy24_logo.png'
import mbankLogo from 'zdjecia/mbank.png'
import { DARK_BUTTON_COLOR } from "App";

// import CONFIG from '../../cfg/config';

const odstep: string = '          ';

interface FooterProps extends WithTranslation , WithStyles<typeof styles> {
    page: IPageState,
    openKlawiatura: () => void,
}

class Footer extends React.Component<FooterProps , any> {

    logoClick = () => {
        window.open("http://virtualsc.com.pl/")
    }

  render() {
    const classes = this.props.classes;

    let linkMbank = "https://pdf.mbank.pl/mbankpl/of/regulaminy/uslugi/regulamin_uslug_platniczych_dla_osob_fizycznych_i_klientow_private_banking_w_ramach_bankowosci_detalicznej_mbanku_s.a._od_13.09.2023_r.pdf"
    let color = "#5F9EA0"

    return (
        <div style={{ padding: "10px 0px 0px", margin: 'auto', alignItems: "center", maxWidth: "316px", display: "inline"}} > {/*onClick={this.logoClick}*/} {/*cursor: "pointer"*/}
           
        <ThemeProvider theme={createTheme({
          palette: {
            primary: {
              main: `${color}`,
            },
            secondary: {
              main: `rgb(255, 165, 0)`,
            },
          },
        })}>     

          <Grid container spacing={0} justifyContent="center">

          {CONFIG.karnetZasady1 === "1" ?   
            <Grid item xs={6} md={6}>
              <div style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex" }}>
                <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady1Link}`} className={classes.link1} target="_blank">
                  <Button variant="outlined" size="medium" color="primary" className={`${classes.button} ${this.props.page.lightMode ? "" : classes.dark}`}>
                    {CONFIG.karnetZasady1Opis}
                  </Button>
                </a>
              </div>
            </Grid> : null}

            {CONFIG.karnetZasady2 === "1" ?  
            <Grid item xs={6} md={6}>
               <div  style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex"}}>
            <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady2Link}`} className={classes.link1}  target="_blank">
              <Button variant="outlined" size="medium" color="primary" className={` ${classes.button} ${this.props.page.lightMode ? "" : classes.dark}`}>
                {CONFIG.karnetZasady2Opis}
              </Button>    
            </a>
          </div>
            </Grid> : null}

            {CONFIG.karnetZasady3 === "1" ?
            <Grid item xs={6} md={6}>
               <div style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex" }}>
              <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady3Link}`} className={classes.link1} target="_blank">
                <Button variant="outlined" size="medium" color="primary" className={` ${classes.button} ${this.props.page.lightMode ? "" : classes.dark}`}>
                  {CONFIG.karnetZasady3Opis}
                </Button>
              </a>
            </div>
            </Grid> : null}

            <Grid item xs={6} md={6}>
            <div style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex" }}>
              <Button variant="outlined" size="medium" color="secondary" className={` ${classes.button} ${classes.orange}`} style={{textTransform: "uppercase"}} onClick={this.props.openKlawiatura}>
                <b>{"wyszukaj karnet"}</b>
              </Button> 
          </div>
            </Grid> 


          </Grid>

           {/* {CONFIG.karnetZasady1 === "1" ?        
          <div  style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex"}}>
            <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady1Link}`} className={classes.link1} target="_blank" rel="noreferrer">
            <Button variant="outlined" size="medium" color="primary" className={`${classes.button}`}>
                {CONFIG.karnetZasady1Opis}
              </Button>
            </a>     
          </div>
        : null}  

        {CONFIG.karnetZasady2 === "1" ?    
          <div  style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex"}}>
            <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady2Link}`} className={classes.link1}  target="_blank" rel="noreferrer">
              <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}>
                {CONFIG.karnetZasady2Opis}
              </Button>    
            </a>
          </div>
          : null}   

          {CONFIG.karnetZasady3 === "2" ?
            <div style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex" }}>
              <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady3Link}`} className={classes.link1} target="_blank" rel="noreferrer">
                <Button variant="outlined" size="medium" color="primary" className={` ${classes.button}`}>
                  {CONFIG.karnetZasady3Opis}
                </Button>
              </a>
            </div>
            : null}   

          <div style={{ textAlign: 'center', padding: "4px 4px", display: "inline-flex" }}>
            <a href={`https://vsc24.net/vscZasady/zasady/Regulamin/${CONFIG.karnetZasady3Link}`} className={classes.link1} target="_blank" rel="noreferrer">
              <Button variant="outlined" size="medium" color="secondary" className={` ${classes.button}`}>
                <b>{"wyszukaj karnet"}</b>
              </Button>
            </a>
          </div> */}

        </ThemeProvider> 

        

        {/* {CONFIG.karnetIkonaPrzelewy24 === "1" ?
          <div style={{ textAlign: 'center', marginBottom: "1px", padding: "15px 20px 10px"}}>
            <a className={classes.alignCenter} href={`https://vsc24.net/vscZasady/zasady/Przelewy24/${CONFIG.hotelID}`} target="_blank" rel="noreferrer">
              
              <img src={platnosciLogo} className={`${classes.imgP24} `} alt="Płatności Przelewy24" />
            </a>
          </div>
          : null} */}
          {/* require('./Przelewy24_logo.png').default */}

        {CONFIG.karnetIkonaMBank === "1" ?
          <div style={{ textAlign: 'center', marginBottom: "1px", padding: "15px 20px 10px"}}>
            <a className={classes.alignCenter} href={linkMbank} target="_blank" rel="noreferrer">
              {/* require('./Przelewy24_logo.png').default */}
              <img src={mbankLogo} className={`${classes.imgP24} `} alt="Płatności Przelewy24" />
            </a>
          </div>
          : null}

      </div>
    );
  }
}

const styles = (theme: Theme) => ({
    link: {
        textDecoration: 'none',
        lineBreak: 'anywhere' as 'anywhere',
        color: theme.palette.error.main
      },
      link1: {
        textDecoration: 'none',
       },
      alignCenter: {
        display: 'block',
        textAlign: 'center' as 'center'
      },
      linkButton: {
        //color: '#3a87ad',
        color: 'rgb(0, 128, 128)',
        "&:hover": {
            textDecoration: "underline"
        }
    },
      button: {
        padding: "5px 5px",
        borderRadius: "0",
        borderColor: "lavender",
        fontSize: '12px',
        lineHeight: '1.5',
        letterSpacing: '0.00938em',
        textTransform: 'none' as 'none',
        minWidth: 150,
        width: "65%",

        //"&:hover": {
        //    background: 'none'
        //}
    },
    orange: {
      background: "rgb(250, 150, 0)",
      color: "white",
      borderColor: "rgb(250, 150, 0)",
      

      "&:hover": {
          background: 'rgb(200, 130, 0)',
          borderColor: "rgb(200, 130, 0)",
      }
  },
    imgP24:{
        maxWidth: '100px',
        cursor: "pointer",
        "@media (max-width: 599px)": {
          maxWidth: '80px', 
        }
      },
      dark: {
        backgroundColor: DARK_BUTTON_COLOR,
      }
});


const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});


export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(Footer)));
